import styles from "../styles.module.css";
import { ReactComponent as RowInfoSvg } from "../../../../assets/rowInfo.svg";
import { ReactComponent as InfoDotYellowSvg } from "../../../../assets/infodotyellow.svg";
import { ReactComponent as InfoDotBlueSvg } from "../../../../assets/infodotblue.svg";
import { ReactComponent as InfoDotDangerSvg } from "../../../../assets/infodotdanger.svg";
import { ReactComponent as MessageIconSvg } from "../../../../assets/messageicon.svg";
import { ReactComponent as NoRecordSvg } from "../../../../assets/norecord.svg";
import { ReactComponent as OnlineDotSvg } from "../../../../assets/OnlineDot.svg";
import { ReactComponent as OfflineDotSvg } from "../../../../assets/offlinedot.svg";
import { ReactComponent as BinSvg } from "../../../../assets/Bin.svg";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, Popup } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { ITicketItem } from "../../../../app/models/tickets";

interface Props {
  ticketList: ITicketItem[];
}

const AllTickets = ({ ticketList }: Props) => {
  const [active, setActive] = useState(0);
  const list = [0, 1, 2, 3, 4, 5];
  const colours = ["#32C36C", "#E53511"];
  const navigate = useNavigate();
  return (
    <div className={styles.boxesWrap}>
      {ticketList.length > 0 ? (
        ticketList.map((ticket, index) => {
          return (
            <div key={index} className={styles.userBoxWrapper}>
              <div
                className={
                  index === active
                    ? `${styles.selected} ${styles.userBox}`
                    : styles.userBox
                }
                onClick={() => setActive(index)}
              >
                <div className={styles.userInfo}>
                  <div className={styles.name}>
                    Re: {ticket.title}
                    <span>
                      {" "}
                      <div className={styles.detailsDate}>
                        {ticket.createdAt}{" "}
                      </div>
                    </span>
                  </div>
                  <div className={styles.contact}>
                    {ticket.message[0].message}
                  </div>
                  <div className={styles.detailsStatus}>
                    <div
                      className={`${styles.selected} ${
                        ticket.priority === "Urgent"
                          ? styles.urgent
                          : ticket.priority === "Medium"
                          ? styles.medium
                          : styles.low
                      }`}
                    >
                      {" "}
                      {ticket.priority === "Urgent" ? (
                        <InfoDotDangerSvg />
                      ) : ticket.priority === "Medium" ? (
                        <InfoDotBlueSvg />
                      ) : (
                        <InfoDotYellowSvg />
                      )}
                      {ticket.priority}
                    </div>
                    <MessageIconSvg /> {ticket.message.length}
                  </div>
                </div>

                <div className={styles.infoIcon}>
                  <Popup
                    trigger={<RowInfoSvg />}
                    content={
                      <div className={styles.menu}>
                        <div style={{ cursor: "pointer" }}>
                          {/* {ticket.status ? <OnlineDotSvg /> : <OfflineDotSvg />} */}
                          {ticket.status ? (
                            <div>{ticket.status}</div>
                          ) : (
                            <div>Unresolved</div>
                          )}
                        </div>
                        <hr />
                        <div style={{ cursor: "pointer" }}>
                          {" "}
                          <BinSvg />
                          Delete
                        </div>
                      </div>
                    }
                    on="click"
                    position="bottom right"
                  />
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <div className={styles.norecord}>
          <NoRecordSvg />
        </div>
      )}
    </div>
  );
};
export default observer(AllTickets);
